<div class="card">
  <div class="flex flex-wrap items-center gap-4 mb-6">
    <form [formGroup]="form" class="flex-1 min-w-0">
      <p-iconfield class="w-full">
        <p-inputicon class="pi pi-search" />
        <input class="w-full" formControlName="search" pInputText [placeholder]="'common.label.search' | translate" type="text" />
        @if (form.get('search')?.value) {
          <i (click)="clearSearch()" class="pi pi-times btn-input-clear"></i>
        }
      </p-iconfield>
    </form>
    @if (!loading) {
      <p-button (onClick)="onCreate()" class="btn-primary shrink-0" [label]="'common.button.create' | translate" />
    }
  </div>

  <app-loading [loading]="loading"></app-loading>

  @if (!loading && data) {
    <div class="flex-1 overflow-x-auto w-full">
      <p-table [scrollable]="true" [value]="data.content" scrollHeight="flex">
        <ng-template #header>
          <tr>
            <th style="min-width: 80px">{{ 'page.customer.field.photo' | translate }}</th>
            <th style="min-width: 140px">{{ 'common.label.id' | translate }}</th>
            <th style="min-width: 320px">{{ 'common.label.customer_name' | translate }}</th>
            <th style="min-width: 120px">{{ 'page.customer.field.nickname' | translate }}</th>
            <th style="min-width: 140px">{{ 'page.customer.field.id_card_number' | translate }}</th>
            <th style="min-width: 80px">{{ 'page.customer.field.sex' | translate }}</th>
            <th style="min-width: 120px">{{ 'page.customer.field.nationality' | translate }}</th>
            <th style="min-width: 120px">{{ 'page.customer.field.tel1' | translate }}</th>
            <th style="min-width: 170px">{{ 'common.label.created' | translate }}</th>
            <th style="min-width: 170px">{{ 'common.label.updated' | translate }}</th>
            <th class="center" style="min-width: 80px">{{ 'common.label.action' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template #body let-customer>
          <tr>
            <td>
              <img [src]="customer.photo || 'assets/images/no-image.jpg'" alt="photo" class="photo" />
            </td>
            <td (click)="goView(customer)" class="text-primary cursor-pointer">
              <b>{{ customer.id }}</b>
            </td>
            <td>{{ customer.customerName }}</td>
            <td>{{ customer.nickname || '-' }}</td>
            <td>{{ customer.idCardNumber || '-' }}</td>
            <td>{{ customer.sex ? ('common.options.sex.' + customer.sex | translate) : '-' }}</td>
            <td>{{ customer.nationality || '-' }}</td>
            <td>{{ customer.tel1 || '-' }}</td>
            <td>{{ (customer.created | date: 'dd/MM/yyyy HH:mm') || '-' }}</td>
            <td>{{ (customer.updated | date: 'dd/MM/yyyy HH:mm') || '-' }}</td>
            <td class="center">
              <p-button
                (onClick)="action.toggle($event)"
                icon="pi pi-ellipsis-h"
                severity="secondary"
                type="button"
                variant="outlined"
              />
              <p-popover #action>
                <div (click)="goView(customer)" class="p-3 cursor-pointer flex gap-4 place-items-center">
                  <i class="pi pi-eye"></i>{{ 'page.customer.button.view_customer' | translate }}
                </div>
                <div
                  (click)="goMakeOPD(customer)"
                  class="p-3 cursor-pointer flex gap-4 place-items-center text-primary"
                >
                  <i class="pi pi-clock text-primary"></i>{{ 'page.customer.button.make_queue' | translate }}
                </div>
              </p-popover>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="justify-items-center py-4" colspan="11">
              <img alt="empty" class="pt-8" src="assets/images/no-data.png" width="100" />
              <div class="pb-8 pt-8"><b>{{ 'common.label.no_data' | translate }}</b></div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }

  @if (data && data.content.length > 0 && !loading) {
    <div class="flex justify-center mt-4">
      <p-paginator
        (onPageChange)="fetchData($event)"
        [first]="first"
        [rowsPerPageOptions]="[20, 50, 100]"
        [rows]="data.pageSize"
        [showCurrentPageReport]="true"
        [showJumpToPageDropdown]="false"
        [totalRecords]="data.total"
        currentPageReportTemplate="{first} to {last}"
      />
    </div>
  }
</div>
